import { Box, useMediaQuery } from '@mui/material'
import React from 'react'
import { useTheme } from '@emotion/react';
import SIDEBAR_CONFIG from '../layout/Sidebar/sidebarConfig';

const ThemeBGWrapper = ({ children, bgColor, sx = {} }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isNotLargeScreen = useMediaQuery(theme.breakpoints.down('md'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

    const sidebarWidth = `${SIDEBAR_CONFIG.desktop.expanded}px`;
    const maxWidthCalc = `calc(100% - ${sidebarWidth})`;

    return (
        <Box sx={{ background: bgColor ? bgColor: "#fffdfa", minHeight: 'calc(100dvh - 1.25rem)', maxWidth: isNotLargeScreen ? "100%" : maxWidthCalc, height: '100%', borderRadius: isNotLargeScreen ? 0 : "24px 0 0 0", position: 'fixed', top: isNotLargeScreen ? 0 : '20px', width: '100%', right: 0, ...sx}}>
            {children}
        </Box>
    )
}

export default ThemeBGWrapper
